<template>
    <div class="personal-container">
        <el-tabs class="personal-el-tab" type="card" tab-position="left" v-model="tabActiveName" @tab-click="handleTabClick">
                <el-tab-pane v-for="item in personalMenuList" :key="item.id" :name="item.name">
                    <span slot="label" class="personal-tab-pane-label">
                        <img :src="item.icon" alt="">
                        {{ item.name }}</span>
                </el-tab-pane>
              </el-tabs>
              <div class="personal-list-container">
                    <OrderList v-if="tabActiveName === '我的订单'" />
                    <Wallet v-if="tabActiveName === '我的钱包'" />
              </div>
    </div>
</template>

<script>
    import OrderList from "./components/oderList.vue"
    import Wallet from "./components/wallet.vue"
    export default {
        components:{ OrderList,Wallet },
        data() {
            return {
                tabActiveName:'我的订单',
                personalMenuList:[{
                    name:'我的订单',
                    icon:require('../../assets/order.svg'),
                    id:1
                },
                // {
                //     name:'申请分销',
                //     icon:require('../../assets/team-sales.svg'),
                //     id:2
                // },{
                //     name:'我的海报',
                //     icon:require('../../assets/postcard.svg'),
                //     id:3
                // },{
                //     name:'流水明细',
                //     icon:require('../../assets/order-flow.svg'),
                //     id:4
                // },
                {
                    name:'我的钱包',
                    icon:require('../../assets/wallet.svg'),
                    id:5
                }]
            }
        },
        created() {
            window.scrollTo(0,0)
        },
        methods:{
            handleTabClick(tab) {
              
            }
        }
    }
</script>
<style scoped lang="less">
    @import "~@/styles/mixin.less";
    @import "~@/styles/var.less";
.personal-container {
    width: 1200px;
    margin: 25px auto;
    display: flex;
}
.personal-el-tab /deep/ .el-tabs__item {
        height: 28px;
        line-height: 0;
        padding: 30px 27px;
        border: none !important;
        box-sizing: content-box;
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
    }
    .personal-el-tab /deep/ .el-tabs__item.is-active { 
        border: none !important;
        background: #fff;
    }
    .personal-el-tab /deep/ .el-tabs__nav,
    .personal-el-tab /deep/ .el-tabs__header{
        border: none !important;
    }
    .personal-el-tab .el-tabs--left /deep/.el-tabs__header.is-left {
        margin-right: 0;
    }
    .personal-tab-pane-label{
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 20px;
        font-weight: 600;
        color: @words;
        > img {
            margin-right: 13px;
        }
    }
        .personal-list-container {
        width: 100%;
        padding: 30px 15px;
        display: flex;
        flex: 1;
        background: #fff;
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
        flex-wrap: wrap;
        /* 解决换行后间距过大 */
        align-content: flex-start; 
    }
</style>
<style>
    .personal-el-tab {
        height: 680px;
    }
</style>